/**
 * Get a stable bounding rect for a DOM Range, falling back to the
 * root element rect when the range returns a zero-size rect (e.g.
 * collapsed selections inside empty nodes).
 */
export function getDOMRangeRect(range: Range, rootElement: HTMLElement): DOMRect {
  const rects = range.getClientRects();
  if (rects.length > 0) {
    return rects[0];
  }
  // Fallback: use the range's bounding rect or root element
  const rect = range.getBoundingClientRect();
  if (rect.width === 0 && rect.height === 0) {
    return rootElement.getBoundingClientRect();
  }
  return rect;
}
